exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2TV8yzUjY_R5us-ErYiWH6{position:fixed;top:0;right:0;bottom:0;left:0;background:#222;color:#7d7d7d;z-index:9999;display:flex;flex-direction:column;justify-content:space-between}.TxFWGMRZIE19gx_pITTI3{position:absolute;z-index:99;top:10px;right:10px;cursor:pointer;color:#ccc}.TxFWGMRZIE19gx_pITTI3:hover{color:white}body.gallery-open{overflow:hidden}\n", ""]);

// Exports
exports.locals = {
	"Gallery": "_2TV8yzUjY_R5us-ErYiWH6",
	"exit": "TxFWGMRZIE19gx_pITTI3"
};